<template>
  <div class="title">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
  .title {
    font-size: 24px;
    font-weight: 600;
    margin: 2rem 0 1.5rem;
  }
</style>
